import React, { useContext } from 'react';
import { FormContext } from '../../common/form/FormContext';
import I18n from '../../common/i18n/I18n';
import IconButtonCard from '../../common/components/IconButtonCard';
import { Icons } from '../../common/icons/Icons';

export default ({
    isCreateBlankActivated,
    handleActivatedCreateStates,
    handleStepperData
}: {
    isCreateBlankActivated: boolean;
    handleActivatedCreateStates: (blankCreate: boolean, templateCreate: boolean) => void;
    handleStepperData: (data: any) => void;
}) => {
    const { state } = useContext(FormContext);

    const onCreateBlankSelected = () => {
        handleActivatedCreateStates(!isCreateBlankActivated, false);
        handleStepperData({ type: state?.type, values: null, resourceSchedule: null, selectedTemplateId: null });
    };
    return (
        <IconButtonCard
            id={'create-resource-blank'}
            text={<I18n token="form.resource.crete.your.own" />}
            onClick={onCreateBlankSelected}
            Icon={Icons.DocumentAddOutlined}
            isButtonActivated={isCreateBlankActivated}
        />
    );
};
